import React from 'react';
import PropTypes from 'prop-types';

const WCard = ({ data, onClick }) => {
    const { value, options: { icon, text, size }, next } = data;
    let css = "";
    if (size === "s") {
        css = "small";
    }

    return (
        <div className={`wui w-card ${css}`} onClick={() => onClick && onClick({ value: text, next })}>
            <div className={`wui w-card-container`}>
                {/* Render the icon only if it's set and not empty */}
                {icon ? (
                    <div className={"wui w-card-icon-container"}>
                        <img
                            className={"wui w-card-icon-img"}
                            src={`${process.env.PUBLIC_URL}${icon}`}
                            alt={text}
                        />
                    </div>
                ) : (
                    <div className={"wui w-card-placeholder"}> {/* Placeholder for styling consistency */}
                        {/* Optional: You can add a default message or styling here */}
                    </div>
                )}
                <div
                    className={"wui w-card-title"}
                    dangerouslySetInnerHTML={{ __html: value }}
                ></div>
            </div>
        </div>
    );
};

WCard.propTypes = {
    data: PropTypes.object.isRequired,
    onClick: PropTypes.func,
};

export default WCard;
